import { apiSlice } from "../../api/apiSlice";

export const myActivityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserActivityStats: builder.query({
      query: (userId) => ({
        url: `/api/badges/user/activity-stats/${userId}`,
        method: "GET",
      }),
      providesTags: ["UserActivity", "Points"],
    }),
    getUserTaskBasedBadges: builder.query({
      query: (userId) => ({
        url: `/api/badges/user/get-task-badges/${userId}`,
        method: "GET",
      }),
      providesTags: ["UserActivity"],
    }),
    getUserPointBasedBadges: builder.query({
      query: (userId) => ({
        url: `/api/badges/user/get-point-badges/${userId}`,
        method: "GET",
      }),
      providesTags: ["UserActivity", "Points"],
    }),
    getUserBookBasedBadges: builder.query({
      query: (userId) => ({
        url: `/api/badges/user/get-book-badges/${userId}`,
        method: "GET",
      }),
      providesTags: ["UserActivity"],
    }),
    getUserTimeTrialBasedBadges: builder.query({
      query: (userId) => ({
        url: `/api/badges/user/get-time-trial-badges/${userId}`,
        method: "GET",
      }),
      providesTags: ["UserActivity"],
    }),
    getCompletedCourses: builder.query({
      query: () => ({
        url: `/api/user/courses/completed`,
        method: "GET",
      }),
      providesTags: ["UserActivity"],
    }),
    getBadges: builder.query({
      query: () => ({
        url: "/api/badges",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetUserActivityStatsQuery,
  useGetUserTaskBasedBadgesQuery,
  useGetUserPointBasedBadgesQuery,
  useGetUserBookBasedBadgesQuery,
  useGetUserTimeTrialBasedBadgesQuery,
  useGetCompletedCoursesQuery,
  useGetBadgesQuery,
} = myActivityApiSlice;
